import { Row, Col } from 'antd'
import LanguageDropdown from './LanguageDropdown'
import ConfigurationDropdown from './ConfigurationDropdown'
import ExitIcon from '../Svg/ExitIcon'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation, isDevelopment, isDemoSite } from '../../Helpers/GenericHelpers'
import { useAppSelector } from '../../hooks'
import { Env } from '../../Constants/Configuration'

function Header() {
  const language = useAppSelector(state => state.present.language.value)
  const appVersion = useAppSelector(state => state.present.configuration.appVersion)
  const multiComp = useAppSelector(state => state.present.article.multiCompany)
  const selectConfigurationElementVisible = useAppSelector(
    state => state.present.configuration.workspaceWorkspaceDropdownVisible,
  )

  return (
    <div className='page-header'>
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 7 }}
          xl={{ span: 9 }}
          xxl={{ span: 8 }}
          className={'d-flex-c  align-center '}
        >
          Ver: {appVersion} {isDevelopment() ? Env.Develop : isDemoSite() ? Env.Demo : ''}{' '}
          {multiComp.active ? ' - ' + multiComp.selected.name : ''}
        </Col>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          xxl={{ span: 8 }}
          className={'d-flex-c  justify-center'}
        >
          <div>{renderTranslation(language, TranslationKeys.headerTitle)}</div>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 11 }}
          xl={{ span: 9 }}
          xxl={{ span: 8 }}
          className={'d-flex-c  justify-center'}
        >
          <LanguageDropdown />
          {selectConfigurationElementVisible ? (
            <>
              <ConfigurationDropdown />
              <span className='icon-block exit d-none'>
                <ExitIcon className={'exit-icon'} />
              </span>
            </>
          ) : null}
        </Col>
      </Row>
    </div>
  )
}

export default Header
